import { useTranslation } from 'react-i18next'

const languages = [
	{ code: 'pl', label: 'Polski', icon: '🇵🇱' },
	{ code: 'en', label: 'English', icon: '🇬🇧' },
]

export default function LanguageSwitcher() {
	const { i18n, t } = useTranslation()

	const currentLanguage = i18n.resolvedLanguage || i18n.language || 'pl'

	return (
		<div className="mt-4">
			{/* <p className="mb-2 block text-xs font-semibold text-indigo-100">
				{t('languageSwitcher.label')}
			</p> */}
			<div className="flex items-center gap-2">
				{languages.map(language => (
					<button
						key={language.code}
						type="button"
						onClick={() => i18n.changeLanguage(language.code)}
						title={language.label}
						aria-label={language.label}
						className={`flex h-9 w-9 items-center justify-center rounded-full border text-lg transition ${
							currentLanguage === language.code
								? 'border-indigo-200 bg-indigo-600'
								: 'border-indigo-500/40 bg-indigo-700 hover:border-indigo-300'
						}`}>
						<span aria-hidden="true">{language.icon}</span>
					</button>
				))}
			</div>
		</div>
	)
}
